/**
 * Turn a machine key into a human label:
 * ``downloaded_count`` → "Downloaded Count", ``baseDir`` → "Base Dir".
 */
export function humanizeKey(key: string): string {
  return key
    .replace(/[_-]+/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
